export type ExecutionEventTypeValue = 6 | 7 | 8 | 9;

export type ExecutionEventOption = {
  value: ExecutionEventTypeValue;
  label: string;
};

export const executionEventOptions: ExecutionEventOption[] = [
  { value: 6, label: "On Time Pickup & Delivery" },
  { value: 7, label: "On Time Pickup, Late Delivery" },
  { value: 8, label: "On Time Delivery, Late Pickup" },
  { value: 9, label: "Failure To Pickup Or Deliver On Time" }
];

export const executionEventTypeValues = new Set<number>(executionEventOptions.map(option => option.value));
